import { FillGradient, Graphics, Sprite } from 'pixi.js';
import { TILE_HEIGHT, TILE_Z_OFFSET } from './TileView';

const gradientHeight = 25;
const obscuredMinTiles = Math.max(Math.floor(TILE_HEIGHT / TILE_Z_OFFSET) - 2, 0);

export function createStackHintMask(tilesBelow: number): Sprite {
  const maskHeight = tilesBelow * TILE_Z_OFFSET + TILE_HEIGHT;
  const fillHeight = (tilesBelow - obscuredMinTiles) * TILE_Z_OFFSET + TILE_HEIGHT;
  const gradientFill = new FillGradient(0, 0, 0, fillHeight);

  const ratio = gradientHeight / fillHeight;
  gradientFill.addColorStop(Math.max(1 - ratio, 0), 0x0000000);
  gradientFill.addColorStop(1, 0xffffff);

  const graphics = new Graphics();
  graphics.rect(0, 0, 200, maskHeight).fill(gradientFill);

  const { pixi } = graphics;
  const texture = pixi.renderer.generateTexture(graphics);
  const maskSprite = new Sprite(texture);

  maskSprite.on('destroyed', () => {
    texture.destroy(true);
  });
  maskSprite.anchor.set(0.5, 1);
  return maskSprite;
}
